const YODLEE_BASE_URL = 'https://developer.api.yodlee.com/ysl/restserver'
const CO_BRAND_LOGIN = 'sbCobralphsmith80'
const CO_BRAND_PASSWORD = 'd394c312-6380-4895-bd08-fb446880a77c'
// const LOGIN_NAME = 'sbMemralphsmith801'
// const PASSWORD = 'sbMemralphsmith801#123'
// const LOGIN_NAME = 'sbMemralphsmith802'
// const PASSWORD = 'sbMemralphsmith802#123'
const LOGIN_NAME = 'sbMemralphsmith803'
const PASSWORD = 'sbMemralphsmith803#123'
// const LOGIN_NAME = 'sbMemralphsmith804'
// const PASSWORD = 'sbMemralphsmith804#123'
// const LOGIN_NAME = 'sbMemralphsmith805'
// const PASSWORD = 'sbMemralphsmith805#123'
// const LOGIN_NAME = 'sbMemralphsmith806'
// const PASSWORD = 'sbMemralphsmith806#123'
const FIN_APP_ID = '10003600'
const LOCALE = 'en_US'

class LoginApi {
  post(url, body, headers = {}) {
    Object.assign(headers, {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // mode: 'cors',
    })
    const init = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body),
    }
    return fetch(url, init).then(response => {
      if (!response.ok) {
        console.log('Error:', response)
        throw new Error(response.status)
      }
      return response.json()
    })
  }
}

const coBrandLogin = (
  coBrandUserName = CO_BRAND_LOGIN,
  coBrandPassword = CO_BRAND_PASSWORD,
  locale = LOCALE,
) => {
  const coBrandUrl = `${YODLEE_BASE_URL}/v1/cobrand/login`
  const requestBody = {
    cobrand: {
      cobrandLogin: coBrandUserName,
      cobrandPassword: coBrandPassword,
      locale: locale,
    },
  }
  const loginApi = new LoginApi()
  return loginApi.post(coBrandUrl, requestBody).then(response => {
    // ------ user pick out user session token -------
    return response.session.cobSession
  })
}

const memberLogin = (
  cobSession = cobSessionToken,
  userName = LOGIN_NAME,
  userPassword = PASSWORD,
  locale = LOCALE,
) => {
  const userUrl = `${YODLEE_BASE_URL}/v1/user/login`
  const headers = new Headers({
    Authorization: `{cobSession=${cobSession}}`,
  })
  const requestBody = {
    user: {
      loginName: userName,
      password: userPassword,
      locale: locale,
    },
  }
  const loginApi = new LoginApi()
  return loginApi.post(userUrl, requestBody, headers).then(response => {
    // ------ user pick out user session token -------
    return response.user.session.userSession
  })
}

class AccountApi {
  static get URL() {
    return `${YODLEE_BASE_URL}/v1/accounts`
  }
  get(headers = {}) {
    Object.assign(headers, {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // mode: 'cors',
      // cache: 'default'
    })
    const init = {
      method: 'GET',
      headers: headers,
    }
    return fetch(AccountApi.URL, init).then(response => {
      if (!response.ok) {
        throw new Error('Error:', response)
      }
      return response.json()
    })
  }
  delete(id, headers = {}) {
    Object.assign(headers, {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // mode: 'cors',
      // cache: 'default'
    })
    const init = {
      method: 'DELETE',
      headers: headers,
    }
    return fetch(`${AccountApi.URL}/${id}`, init).then(response => {
      if (!response.ok) {
        throw new Error('Error:', response)
      }
      return response
    })
  }
}
const getAccounts = (cobSessionToken, userSessionToken) => {
  const headers = new Headers({
    Authorization: `{userSession=${userSessionToken},cobSession=${cobSessionToken}}`,
  })
  const accountApi = new AccountApi()
  return accountApi.get(headers)
}

const deleteAccount = (id, cobSessionToken, userSessionToken) => {
  const headers = new Headers({
    Authorization: `{userSession=${userSessionToken},cobSession=${cobSessionToken}}`,
  })
  const accountApi = new AccountApi()
  return accountApi.delete(id, headers)
}

const accountsSummary = accounts => {
  console.table(accounts)
  let summary = accounts.reduce(
    (summary, account) => {
      if (account.includeInNetWorth && account.isAsset) {
        summary.netWorth += account.balance.amount
        summary.assets += account.balance.amount
      }
      if (account.includeInNetWorth && !account.isAsset) {
        summary.netWorth -= account.balance.amount
        summary.expenses += account.balance.amount
      }
      return summary
    },
    {
      assets: 0,
      expenses: 0,
      netWorth: 0,
    },
  )
  // round to the nearest whole number
  return Object.assign({}, summary, {
    assets: Math.round(summary.assets),
    expenses: Math.round(summary.expenses),
    netWorth: Math.round(summary.netWorth),
  })
}

class FastLinkApi {
  get(headers = {}) {
    const URL = `${YODLEE_BASE_URL}/v1/user/accessTokens?appIds=${FIN_APP_ID}`
    Object.assign(headers, {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // mode: 'cors',
      // cache: 'default'
    })
    const init = {
      method: 'GET',
      headers: headers,
    }
    return fetch(URL, init).then(response => {
      if (!response.ok) {
        throw new Error('Error:', response)
      }
      return response.json()
    })
  }
}

const getFastLinkToken = (cobSessionToken, userSessionToken) => {
  const headers = new Headers({
    Authorization: `{userSession=${userSessionToken},cobSession=${cobSessionToken}}`,
  })
  const fastLinkApi = new FastLinkApi()
  return fastLinkApi.get(headers).then(response => {
    // ------ pick out first fast link token -------
    return response.user.accessTokens[0]
  })
}

class TransactionSummaryApi {
  static get URL() {
    return `${YODLEE_BASE_URL}/v1/derived/transactionSummary`
  }
  get(url = TransactionSummaryApi.URL, headers = {}) {
    Object.assign(headers, {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    })
    const init = {
      method: 'GET',
      headers: headers,
    }
    return fetch(url, init).then(response => {
      if (!response.ok) {
        throw new Error('Error:', response)
      }
      return response.json()
    })
  }
}

const getExpenses = (cobSessionToken, userSessionToken) => {
  const headers = new Headers({
    Authorization: `{userSession=${userSessionToken},cobSession=${cobSessionToken}}`,
  })
  const queryParams = {
    groupBy: 'CATEGORY',
    categoryType: 'EXPENSE',
    // D-daily, W-weekly, M-mothly or Y-yearly
    interval: 'Y',
  }
  const query = Object.keys(queryParams)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(queryParams[k])}`)
    .join('&')
  const url = `${TransactionSummaryApi.URL}?${query}`
  const transactionSummaryApi = new TransactionSummaryApi()
  return transactionSummaryApi.get(url, headers).then(response => {
    return response
  })
}

class NetworthApi {
  static get URL() {
    return `${YODLEE_BASE_URL}/v1/derived/networth`
  }
  get(url = networthApi.URL, headers = {}) {
    Object.assign(headers, {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    })
    const init = {
      method: 'GET',
      headers: headers,
    }
    return fetch(url, init).then(response => {
      if (!response.ok) {
        throw new Error('Error:', response)
      }
      return response.json()
    })
  }
}

const getNetworth = (cobSessionToken, userSessionToken) => {
  const headers = new Headers({
    Authorization: `{userSession=${userSessionToken},cobSession=${cobSessionToken}}`,
  })
  const today = new Date()
  const date = today.toLocaleDateString('en').split('/')
  const month = date[0]
  const day = date[1]
  const year = date[2]
  const YYYY = year
  const MM = month < 10 ? `0${month}` : month
  const DD = day < 10 ? `0${day}` : day
  const queryParams = {
    fromDate: `${YYYY}-${MM}-${DD}`,
    toDate: `${YYYY}-${MM}-${DD}`,
  }
  const query = Object.keys(queryParams)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(queryParams[k])}`)
    .join('&')
  const url = `${NetworthApi.URL}?${query}`
  const networthApi = new NetworthApi()
  return networthApi.get(url, headers).then(response => {
    return response
  })
}

export {
  coBrandLogin,
  memberLogin,
  getAccounts,
  accountsSummary,
  getExpenses,
  getNetworth,
  getFastLinkToken,
}



// WEBPACK FOOTER //
// ./api/yodlee/yodlee.js